import React, { memo } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { Stack, Button, Icon, TextField } from 'investira.react.components';
import { BaseTemplate } from '../../../components/templates';
import withMessage from '../../../hoc/withMessage';
import services from '../../../services';

const AvaliacoesSettingsSecaoAdd = memo(props => {
  const navigate = useNavigate();

  const VALIDATION_SCHEMA = Yup.object().shape({
    titulo: Yup.string().trim().required('Informe o título da seção.'),
    alias: Yup.string().trim().required('Informe o alias da seção.'),
    descricao: Yup.string().trim().nullable()
  });

  const formik = useFormik({
    initialValues: {
      titulo: '',
      alias: '',
      tooltip: '',
      descricao: ''
    },
    validationSchema: VALIDATION_SCHEMA,
    validateOnMount: false,
    onSubmit: pValues => {
      const xPayload = {
        avaliacao_secao: pValues.titulo.trim(),
        avaliacao_secao_descricao: pValues.descricao.trim(),
        avaliacao_secao_sigla: pValues.alias.trim()
      };

      services.secoes.add(
        xPayload,
        () => {
          props.onMessageSuccess?.('Seção criada com sucesso.');
          navigate('/avaliacoes/configuracoes/secoes');
        },
        rErr => {
          props.onMessageError?.(rErr?.message || 'Não foi possível criar a seção.');
        }
      );
    }
  });

  const handleSave = () => formik.submitForm();

  return (
    <BaseTemplate
      title={'Nova Seção'}
      subtitle={'Configurações'}
      description="Informe o objetivo e a finalidade desta sessão para organizar e estruturar melhor os critérios da avaliação."
      maxWidth={'xl'}>
      <Stack gap={2} py={3}>
        <Stack direction="row" gap={2} alignItems="flex-start">
          <Stack flex={1}>
            <TextField
              label="Seção"
              placeholder="Ex.: Análise Fundamentalista"
              value={formik.values.titulo}
              onChange={formik.handleChange('titulo')}
              onBlur={formik.handleBlur('titulo')}
              error={formik.touched.titulo && Boolean(formik.errors.titulo)}
              helperText={formik.touched.titulo ? formik.errors.titulo : ''}
              fullWidth
              InputLabelProps={{ shrink: true }}
              variant="outlined"
            />
          </Stack>

          <Stack sx={{ width: '120px' }}>
            <TextField
              label="Alias"
              placeholder="A"
              value={formik.values.alias}
              onChange={formik.handleChange('alias')}
              onBlur={formik.handleBlur('alias')}
              error={formik.touched.alias && Boolean(formik.errors.alias)}
              helperText={formik.touched.alias ? formik.errors.alias : ''}
              fullWidth
              InputLabelProps={{ shrink: true }}
              variant="outlined"
            />
          </Stack>
        </Stack>

        <Stack gap={2} direction="row">
          <TextField
            label="Descrição"
            placeholder="Descreva o objetivo desta sessão"
            value={formik.values.descricao}
            onChange={formik.handleChange('descricao')}
            onBlur={formik.handleBlur('descricao')}
            error={formik.touched.descricao && Boolean(formik.errors.descricao)}
            helperText={formik.touched.descricao ? formik.errors.descricao : ''}
            fullWidth
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            multiline
            rows={4}
          />

          <TextField
            label="Tooltip"
            placeholder="Informações complementares"
            value={formik.values.tooltip}
            onChange={formik.handleChange('tooltip')}
            onBlur={formik.handleBlur('tooltip')}
            error={formik.touched.tooltip && Boolean(formik.errors.tooltip)}
            helperText={formik.touched.tooltip ? formik.errors.tooltip : ''}
            fullWidth
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            multiline
            rows={4}
          />
        </Stack>

        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button
            disabled={props.disabledButtons}
            variant="contained"
            color="primary"
            startIcon={<Icon iconName="upload" size={16} />}
            size="small"
            sx={{ px: 2 }}
            onClick={handleSave}>
            Salvar
          </Button>
        </Stack>
      </Stack>
    </BaseTemplate>
  );
});

export default withMessage(AvaliacoesSettingsSecaoAdd);
